import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TocDetailPage } from './toc-detail';

const routes: Routes = [
  {
    path: '',
    component: TocDetailPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TocDetailPageRoutingModule { }
